<template>
  <el-drawer :visible.sync="menuAccessshow" :title="'权限配置 · ' + roleName" :size="640" :wrapper-closable="false" :modal="false" :destroy-on-close="true" :before-close="beforeClose" class="margin_top_40">
    <div class="permission-body" v-loading="saving">
      <el-tabs v-model="activeTab" @tab-click="loadActive">
        <el-tab-pane v-for="platform in platforms" :key="platform.id" :name="platform.id" :label="platform.label + (states[platform.id].dirty ? ' · 未保存' : '')">
          <div v-loading="states[platform.id].loading">
            <lcsj-filter :show-search="false"><el-form-item label="关键词："><el-input v-model="states[platform.id].filter" clearable size="small" placeholder="菜单或按钮" @input="filterTree(platform.id)" /></el-form-item></lcsj-filter>
            <p class="permission-help">仅修改当前端权限；隐藏菜单也可授权。保存后用户刷新权限或重新登录生效。</p>
            <el-button v-if="states[platform.id].error" size="small" @click="loadPlatform(platform.id)">加载失败，点击重试</el-button>
            <el-tree v-if="states[platform.id].loaded" :ref="'tree' + platform.id" :data="states[platform.id].nodes" :props="treeProps" node-key="keyId" show-checkbox :filter-node-method="filterNode" :default-checked-keys="states[platform.id].checked" @check="markDirty(platform.id)" />
            <el-empty v-if="states[platform.id].loaded && !states[platform.id].nodes.length" description="当前端暂无可授权菜单" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="drawer-footer">
      <el-button size="small" :disabled="saving || !current.loaded" @click="clearCurrent">清空当前端</el-button>
      <el-button size="small" type="primary" :loading="saving" :disabled="!current.loaded" @click="menuPermSave">保存当前端权限</el-button>
      <el-button size="small" :disabled="saving" @click="closeDialog">关闭</el-button>
    </div>
  </el-drawer>
</template>

<script>
import { GetOnLineMenuTreeList, GetRoleLinkMenu2List, SaveRoleLinkMenu2 } from "../../../api/menuApi.js";
import { permissionTree, checkedLeaves, permissionDetails } from "./permissionTree.js";
function state() { return { nodes: [], checked: [], loaded: false, loading: false, dirty: false, error: false, filter: "" }; }
export default {
  data() {
    return {
      menuAccessshow: false, roleId: "", roleName: "", activeTab: "1", saving: false, session: 0,
      platforms: [{ id: "1", label: "Web端权限" }, { id: "3", label: "App端权限" }],
      states: { "1": state(), "3": state() }, treeProps: { children: "subList", label: "menuName" }
    };
  },
  computed: { current() { return this.states[this.activeTab]; } },
  methods: {
    menuAccess(row) {
      this.session++;
      this.roleId = row.keyId; this.roleName = row.roleName || "";
      this.states = { "1": state(), "3": state() }; this.activeTab = "1";
      this.menuAccessshow = true; this.loadActive();
    },
    tree(id) { const ref = this.$refs["tree" + id]; return Array.isArray(ref) ? ref[0] : ref; },
    loadActive() { this.loadPlatform(this.activeTab); },
    async loadPlatform(id) {
      const target = this.states[id];
      if (target.loaded || target.loading) return;
      const session = this.session;
      target.loading = true; target.error = false;
      try {
        const params = { keyId: this.roleId, menuType: Number(id) };
        const [menus, grants] = await Promise.all([GetOnLineMenuTreeList(params), GetRoleLinkMenu2List(params)]);
        if (session !== this.session) return;
        if (menus.code !== 1 || grants.code !== 1) throw new Error(menus.code !== 1 ? menus.msg : grants.msg);
        target.nodes = permissionTree(menus.data || []);
        target.checked = checkedLeaves(target.nodes, grants.data || []);
        target.loaded = true;
      } catch (err) {
        if (session !== this.session) return;
        target.error = true; this.$message.error(err.message || "加载权限失败，请重试");
      } finally { target.loading = false; }
    },
    filterNode(value, data) { return !value || data.menuName.includes(value); },
    filterTree(id) { const tree = this.tree(id); if (tree) tree.filter(this.states[id].filter); },
    markDirty(id) { this.states[id].dirty = true; },
    clearCurrent() { const tree = this.tree(this.activeTab); if (tree) { tree.setCheckedKeys([]); this.current.dirty = true; } },
    async menuPermSave() {
      if (this.saving || !this.current.loaded) return;
      const id = this.activeTab, target = this.states[id], tree = this.tree(id);
      if (!tree) return;
      const params = { keyId: this.roleId, menuType: Number(id), dtls: permissionDetails(tree.getCheckedNodes(), tree.getHalfCheckedNodes()) };
      this.saving = true;
      try {
        const res = await SaveRoleLinkMenu2(params);
        if (res.code !== 1) throw new Error(res.msg);
        target.dirty = false;
        this.$message.success((id === "1" ? "Web" : "App") + "端权限已保存");
      } catch (err) { this.$message.error(err.message || "权限保存失败，请重试"); }
      finally { this.saving = false; }
    },
    async beforeClose(done) {
      if (this.saving) return;
      if (Object.values(this.states).some(item => item.dirty)) {
        try { await this.$confirm("存在未保存的权限修改，确定放弃并关闭吗？", "未保存修改", { type: "warning", confirmButtonText: "放弃并关闭", cancelButtonText: "继续编辑" }); }
        catch (_) { return; }
      }
      this.session++; done();
    },
    closeDialog() { this.beforeClose(() => { this.menuAccessshow = false; }); }
  }
};
</script>
<style scoped>
.permission-body { padding: 0 20px 80px; }
.permission-help { font-size: 12px; color: var(--app-text-secondary); line-height: 1.6; }
</style>
